import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const HomePage: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="text-center">
      <h1 className="mb-8">Applied Security Force</h1>
      <h2 className="mb-8">Missing Child Protocol</h2>
      
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <p className="mb-4">
          This system helps manage child registration and contact tracing for ASF events.
        </p>
        
        {user ? (
          <div>
            <p className="mb-4">Welcome, {user.name}!</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              {user.roles.includes('admin') && (
                <Link to="/admin" className="btn btn-primary">
                  Manage Events
                </Link>
              )}
              <Link to="/lookup" className="btn btn-primary">
                Lookup Registration
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <p className="mb-4">
              Staff members can log in to access event management and lookup tools.
            </p>
            <Link to="/login" className="btn btn-primary">
              Staff Login
            </Link>
          </div>
        )}
      </div>
      
      <div className="mt-8">
        <h3 className="mb-4">For Parents</h3>
        <p className="mb-4">
          If you have a registration link or QR code from an event, you can register your children here.
        </p>
        <p className="text-sm text-gray-600">
          Registration links are provided at ASF events or sent via email.
        </p>
      </div>
    </div>
  )
}

export default HomePage
